import { Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { PageHeader } from '@/components/navigation/PageHeader';

export function ClientTasksPage() {
  return (
    <Stack>
      <PageHeader heading="Tasks" />
      <Stack p={2} flex={1}>
        <Outlet />
      </Stack>
    </Stack>
  );
}
